import { extendTheme } from "@chakra-ui/react";

const config = { initialColorMode: "system" };

const theme = extendTheme({ config });

export default theme;
